import Application from "../../Application";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";
import { ICodebookService } from "../service/CodebookService";

export default class UpdateGenericCodebookItemInteractor {
  private application: Application;
  private codebookService: ICodebookService;

  constructor({ application, codebookService }: any) {
    this.application = application;
    this.codebookService = codebookService;
  }

  async execute(valueListItem: IGenericCodebookItem) {
    return this.codebookService.updateGenricCodebookItem(valueListItem);
  }
}
